import { useLayoutEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useAuth } from '@/lib/auth';
import { isExhibitionKioskAllowedPath, isExhibitionKioskUser } from '@/lib/exhibition';
import { RegistrationApprovalRedirect } from '@/components/RegistrationApprovalRedirect';

/**
 * Restricts unclaimed exhibition kiosk users to the industry picker and chat routes.
 */
export function ExhibitionKioskRedirect() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isLoading } = useAuth({ tmp: 'ExhibitionKioskRedirect' });
  const path = location.pathname;

  const isKiosk = isExhibitionKioskUser(user);
  const allowed = isExhibitionKioskAllowedPath(path);

  useLayoutEffect(() => {
    if (isLoading || !user || !isKiosk || allowed) return;
    navigate('/exhibition/start', { replace: true });
  }, [isLoading, user, isKiosk, allowed, navigate]);

  return <RegistrationApprovalRedirect />;
}
